import React, { useEffect, useMemo, useState } from "react";
import "./payments.css";
import useAuth from "../../../hooks/useAuth";

import { toast } from "react-toastify";
import axiosInstance from "../../../helpers/axiosInstance";
import AuthorizedContent from "../../../shared/AuthorizedContent";
import FlipLoader from "../../../shared/fliploader/FlipLoader";
import { ReactComponent as ArrowIcon } from "../../../assets/signin/right.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/signin/delete.svg";
import { ReactComponent as ProfileIcon } from "../../../assets/navbar/profile.svg";
import { ReactComponent as PendingIcon } from "../../../assets/pending.svg";
import { ReactComponent as CheckedIcon } from "../../../assets/check.svg";
// import { ReactComponent as FilterIcon } from "../../../assets/filter.svg";
import { ReactComponent as PlusIcon } from "../../../assets/plus.svg";
import { filterLoanID } from "../../../helpers/filterLoanId";
import { formatAmount } from "../../../helpers/formatAmount";
import { AnimatePresence, motion } from "framer-motion";
import GooglePayButton from "@google-pay/button-react";

function Payments(props) {
  const [paymentList, setPaymentList] = useState([]);
  const { organisation, auth } = useAuth();
  const [amount, setAmount] = useState(500);
  const [comment, setComment] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [membersList, setMembersList] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");

  useEffect(() => {
    getInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getInitialData = () => {
    if (auth.user.role === "member" || props.parent === "details") {
      getAllPaymentList();
    } else {
      getAllMembers();
      getMemberPayments();
    }
  };
  const getAllPaymentList = () => {
    axiosInstance
      .get(`/api/payment/${organisation._id}/getallpayments`)
      .then((response) => {
        setPaymentList(response.data.data);
        setLoading(false);
        console.log(response.data);
      })
      .catch((error) => {
        setLoading(false);
        toast("Unable to get payments. Try again!");
        console.log(error);
      });
  };

  const getAllMembers = () => {
    axiosInstance
      .get(`/api/member/${organisation._id}/getallminimalmembers`)
      .then((response) => {
        setMembersList(response.data);
      })
      .catch((error) => {
        toast("Unable to get members list. Try again!");
        console.log(error);
      });
  };

  const getMemberPayments = () => {
    axiosInstance
      .get(`/api/payment/${organisation._id}/members/${auth.user._id}/payments`)
      .then((response) => {
        setPaymentList(response.data.data);
        setLoading(false);
        console.log(response.data);
      })
      .catch((error) => {
        setLoading(false);
        toast("Unable to get payments. Try again!");
        console.log(error);
      });
  };

  const handleDelete = (id) => {
    setLoading(true);
    axiosInstance
      .delete(`/api/payment/${organisation._id}/deletepayment/${id}`)
      .then((response) => {
        setLoading(false);
        toast("Payment Transaction deleted successfully");
        getInitialData();
        console.log(response.data);
      })
      .catch((error) => {
        setLoading(false);
        toast("Unable to delete Payment Transaction . Try again!");
        console.log(error);
      });
  };

  const renderModal = () => {
    // let filteredend_date = new Date(end_date).toLocaleDateString("en-uk", {
    // weekday: "long",
    // day: "numeric",
    // year: "numeric",
    // month: "numeric",
    // });
    // console.log(filteredend_date);
    return (
      <motion.section
        className="payments-modal-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
        transition={{ duration: 0.2 }}
      >
        <header className="payments-modal-header">
          <ArrowIcon className="payments-modal-lefticon" onClick={() => setShowModal(false)} />
          Send Money to Oragnization
        </header>
        <main className="payments-modal-body">
          <div className="payments-form">
            <label className="required"> Amount</label>
            <input
              type="text"
              value={amount || ""}
              minLength={500}
              name="amount"
              onChange={({ target }) => {
                setAmount(parseInt(target.value));
              }}
              required={true}
            />
          </div>

          <div className="payments-form">
            <label>Remarks</label>
            <input
              type="text"
              name="remark"
              onChange={({ target }) => {
                setComment(target.value);
              }}
              // placeholder={end_date}
              value={comment || ""}
            // required={true}
            />
          </div>
        </main>
        <footer className="payments-modal-footer">
          {" "}
          {/* <a
            href={`upi://pay?pa=9844286170@upi&&am=1.0&pn=YouthAllianceFund&cu=INR`}
          > */}
          {/* <button className="payments-addbtn" onClick={handleSubmit}>
            Submit
          </button> */}
          <GooglePayButton
            environment="PRODUCTION"
            paymentRequest={{
              apiVersion: 2,
              apiVersionMinor: 0,
              allowedPaymentMethods: [
                {
                  type: "CARD",
                  parameters: {
                    allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                    allowedCardNetworks: ["MASTERCARD", "VISA"],
                  },
                  tokenizationSpecification: {
                    type: "PAYMENT_GATEWAY",
                    parameters: {
                      gateway: "example",
                      gatewayMerchantId: "exampleGatewayMerchantId",
                    },
                  },
                },
              ],
              merchantInfo: {
                merchantId: "BCR2DN4TZLDJ3UZV",
                merchantName: "Demo Merchant",
              },
              transactionInfo: {
                totalPriceStatus: "FINAL",
                totalPriceLabel: "Total",
                totalPrice: "1",
                currencyCode: "INR",
                countryCode: "IN",
              },
              shippingAddressRequired: true,
              callbackIntents: ["SHIPPING_ADDRESS", "PAYMENT_AUTHORIZATION"],
            }}
            onLoadPaymentData={(paymentRequest) => {
              console.log("Success", paymentRequest);
            }}
            onPaymentAuthorized={(paymentData) => {
              console.log("Payment Authorised Success", paymentData);
              return { transactionState: "SUCCESS" };
            }}
            onPaymentDataChanged={(paymentData) => {
              console.log("On Payment Data Changed", paymentData);
              return {};
            }}
            existingPaymentMethodRequired="false"
            buttonColor="black"
            buttonType="Buy"
          />
          {/* </a> */}
        </footer>
      </motion.section>
    );
  };

  const handleSubmit = () => {
    // console.log(checkRequiredFields());
    if (!amount) {
    } else {
      setLoading(true);
      setShowModal(false);
      axiosInstance
        .post(`/api/payment/${organisation._id}/addpayment/${props.selectedMember._id}`, {
          amount: parseInt(amount),
        })
        .then((response) => {
          toast("Member payment added successfully");
          getInitialData();
          console.log(response.data);
        })
        .catch((error) => {
          setLoading(false);
          toast("Unable to add Payment  details. Try again!");
          console.log(error);
        });
    }
  };

  return (
    <div className="payments-container">
      <AnimatePresence>{showModal ? renderModal() : null}</AnimatePresence>
      {/* {selectedDetail ? renderDetailModal() : null} */}
      {/* {showFilterModal ? rendrFilterModal() : null} */}
      <div className="payments-header">
        {props.parent !== "details" ? <h3 className="payments-heading">Payment Transactions</h3> : null}
        {/* <button
      className="applyloan-filterbtn"
      onClick={() => setshowFilterModal(true)}
    >
      <FilterIcon />
    </button> */}
        <AuthorizedContent roles={["member", "secretary", "director"]}>
          <button className="payments-addiconbtn" onClick={() => setShowModal(true)}>
            <PlusIcon />
          </button>
        </AuthorizedContent>
      </div>
      <div className="payments-wrapper">
        {loading ? (
          <div className="payments-loader">
            <FlipLoader />
          </div>
        ) : !paymentList?.length ? (
          <p>There are no loan forms.</p>
        ) : (
          <div className="payments-listwrapper">
            {/* <motion.header
          className="applyloan-listwrapper-header"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.1 }}
        >
          <label className="applyloan-listwrapper-headerleft">
            <label>
              Active : <span>{transactionMetdata.active_loan}</span>
            </label>{" "}
            <label>
              Closed : <span>{transactionMetdata.closed_loan}</span>
            </label>
          </label>
          <label className="applyloan-listwrapper-headerright">
            Total Loan Amount :{" "}
            <span>₹ {formatAmount(transactionMetdata.total_loan)}</span>{" "}
          </label>
        </motion.header> */}
            {paymentList?.map((transaction, idx) => {
              let date = new Date(transaction.payment_date || transaction.date).toLocaleDateString("en-us", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              });
              return (
                <motion.div
                  className={
                    transaction.status === 0
                      ? "payments-list payments-list-pending"
                      : transaction.status === 1
                        ? "payments-list payments-list-adminpending"
                        : "payments-list"
                  }
                  key={idx}
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <div className="payments-listleft">
                    <p className="payments-listleft-date">{date}</p>
                    {/* {props.parent !== "details" &&
                auth.user.role !== "member" ? ( */}
                    <p className=" applyloan-listleft-user">
                      <ProfileIcon /> {transaction.member.first_name} {transaction.member.last_name}
                    </p>
                    {/* // ) : null} */}
                    <p
                      className="payments-listleft-id"
                      onClick={() => {
                        // setSelectedDetail(transaction);
                        // setActive(transaction.active);
                      }}
                    >
                      {filterLoanID(transaction._id, transaction.payment_date || transaction.date)}{" "}
                      <span
                        className={
                          (transaction.status === 0) | (transaction.status === 1)
                            ? "payments-listleft-status  payments-listleft-status-pending"
                            : "payments-listleft-status payments-listleft-status-checked"
                        }
                      >
                        {transaction.status === 0 || transaction.status === 1 ? <PendingIcon /> : <CheckedIcon />}
                        <span>{transaction.status === 1 ? "Pending" : "Approved"}</span>
                      </span>{" "}
                    </p>
                  </div>
                  <label
                    className={
                      auth.user.role === "super-admin" || auth.user.role === "admin"
                        ? "payments-listrighttotal"
                        : "payments-listrighttotal payments-listrightmember"
                    }
                  >
                    ₹ {formatAmount(transaction.total_amount)}
                  </label>

                  <AuthorizedContent roles={["super-admin", "admin"]}>
                    <div className="payments-listrightdelete" onClick={() => handleDelete(transaction._id)}>
                      <DeleteIcon />
                    </div>
                  </AuthorizedContent>
                </motion.div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Payments;
